var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$vlastMode
    ? _c("div", { staticClass: "container-fluid" }, [
        !_vm.optedIn
          ? _c(
              "div",
              [
                _c("campaign-notification", {
                  attrs: {
                    theme: "light",
                    icon: "heart",
                    title:
                      "Looking for a meaningful way to connect with clients?",
                    heading: "1000 virtual meetings in 100 days",
                    summary:
                      "Jump on our mission to connect sports stars into 1000 virtual meetings in 100 days! We are calling on all our stars to donate your time and be available to join virtual team meetings for just 15 minutes. You more than anyone are equipped with the profile and mindset skills to bring joy and inspiration at a time when people need it the most.",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "buttons",
                        fn: function () {
                          return [
                            _c(
                              "ladda-button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: {
                                  type: "submit",
                                  click: _vm.handleOptInCallback,
                                },
                              },
                              [_vm._v("\n            I'm Keen\n          ")]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    3801282920
                  ),
                }),
              ],
              1
            )
          : _vm.optedIn
          ? _c(
              "div",
              [
                _c("campaign-notification", {
                  attrs: {
                    theme: "light",
                    icon: "check-circle",
                    title: "Thank you!",
                    summary:
                      "We are currently fielding lots of enquiries from a whole range of businesses. We will be in contact with opportunities throughout the next 100 days.",
                    "has-buttons": false,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }